import React from "react";
import {
  Grid,
  GridCell,
  Select,
  SelectOption,
  Label,
} from "@flixbus/honeycomb-react";
import type { OperationalDataPickersProps } from "./OperationalDataPickers.types";
import styles from "./OperationalDataPickers.module.scss";

const OperationalDataPickers: React.FC<OperationalDataPickersProps> = ({
  lines,
  selectedLine,
  years,
  selectedYear,
  disabled,
  onLineChange,
  onYearChange,
}) => {
  const noLines = lines.length === 0;
  const yearDisabled = disabled || selectedLine === null || years.length === 0;

  return (
    <Grid align="start" extraClasses={styles.pickers}>
      <GridCell colSpan={4}>
        <Select
          id="operational-data-line"
          label={<Label text="Line" />}
          placeholder="— Select —"
          value={selectedLine ?? ""}
          disabled={disabled || noLines}
          infoError={noLines ? "No lines available" : undefined}
          onChange={(e) => onLineChange(e.target.value)}
        >
          {lines.map((line) => (
            <SelectOption key={line.id} value={line.code}>
              {line.code}
            </SelectOption>
          ))}
        </Select>
      </GridCell>
      <GridCell colSpan={4}>
        <Select
          id="operational-data-year"
          label={<Label text="Year" />}
          value={selectedYear !== null ? String(selectedYear) : ""}
          disabled={yearDisabled}
          onChange={(e) => onYearChange(Number(e.target.value))}
        >
          {years.map((year) => (
            <SelectOption key={year} value={String(year)}>
              {year}
            </SelectOption>
          ))}
        </Select>
      </GridCell>
    </Grid>
  );
};

export default React.memo(OperationalDataPickers);
